import { useEffect, useState } from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
const BlogDetail = () => {
  const navigate = useNavigate();

  const { slug, category } =
    useParams();

  const [blog, setBlog] = useState(null);

  const [loading, setLoading] =
    useState(true);

  /* =========================
     CLEAN SLUG
  ========================= */

  const cleanSlug =
    slug?.trim() || "";

  /* =========================
     FETCH BLOG DETAIL
  ========================= */

  const fetchBlogDetail = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `https://tekitsolution.com/blog/wp-json/wp/v2/posts?slug=${cleanSlug}&_embed`
      );

      const data = await response.json();

      if (data && data.length > 0) {
        const post = data[0];

        setBlog({
          id: post.id,

          title:
            post.title?.rendered || "",

          content:
            post.content?.rendered ||
            "",

          summary:
            post.excerpt?.rendered ||
            "",

          createdAt: post.date || "",

          featured_image_url:
            post?._embedded?.[
              "wp:featuredmedia"
            ]?.[0]?.source_url || "",

          category:
            category || "blog",
        });
      } else {
        setBlog(null);
      }
    } catch (error) {
      console.error(
        "Error fetching blog detail:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     LOAD BLOG
  ========================= */

useEffect(() => {

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  if (cleanSlug) {
    fetchBlogDetail();
  }

}, [cleanSlug]);

  /* =========================
     LOADING
  ========================= */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">

        <div className="text-2xl font-semibold">
          Loading...
        </div>

      </div>
    );
  }

  /* =========================
     NOT FOUND
  ========================= */

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">

        <div className="text-2xl font-semibold">
          Blog not found
        </div>

      </div>
    );
  }

  return (
    <>
    <Helmet>
      <link rel='canonical' href='https://www.tekit.io/insights/blog' />
    </Helmet>
    <div className="bg-white min-h-screen">

      {/* HERO IMAGE */}

      {blog?.featured_image_url && (
        <div className="w-full overflow-hidden">

          <img
            src={blog.featured_image_url}
            alt={blog.title}
            className="w-full h-full object-cover object-center filter brightness-75"
          />

        </div>
      )}

      {/* BLOG CONTENT */}

      <div className="max-w-5xl mx-auto px-6 py-16">

        {/* BACK BUTTON */}

        <button
          onClick={() =>
            navigate("/blog-page")
          }
          className="mb-8 text-blue-600 hover:underline"
        >
          ← Back to Blogs
        </button>

        {/* CATEGORY */}

        <div className="mb-4">

          <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium capitalize">

            {blog?.category}

          </span>

        </div>

        {/* TITLE */}

        <h1
          className="text-4xl lg:text-5xl font-bold text-black leading-tight"
          dangerouslySetInnerHTML={{
            __html: blog?.title || "",
          }}
        />

        {/* DATE */}

        <p className="text-gray-500 mt-4 mb-10">

          {new Date(
            blog.createdAt
          ).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}

        </p>

        {/* CONTENT */}

        <div
          className="
            prose
            prose-lg
            max-w-none

            prose-h1:text-4xl
            prose-h1:font-bold

            prose-h2:text-3xl
            prose-h2:font-semibold

            prose-h3:text-2xl
            prose-h3:font-semibold

            prose-p:text-gray-700
            prose-p:leading-8

            prose-a:text-blue-600
            hover:prose-a:underline

            prose-ul:list-disc
            prose-ul:pl-6

            prose-ol:list-decimal
            prose-ol:pl-6

            prose-li:marker:text-blue-600

            prose-img:rounded-2xl
            prose-img:shadow-lg
            prose-img:w-full

            prose-table:w-full
            prose-table:border
            prose-table:border-collapse

            prose-th:border
            prose-th:bg-gray-100
            prose-th:p-3

            prose-td:border
            prose-td:p-3

            prose-blockquote:border-l-4
            prose-blockquote:border-blue-500
            prose-blockquote:pl-4
            prose-blockquote:italic
          "
          dangerouslySetInnerHTML={{
            __html: blog?.content || "",
          }}
        />

      </div>

    </div>
    </>
  );
};

export default BlogDetail;